// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  partyId: __t.u64().primaryKey().name("party_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  faction: __t.string(),
  name: __t.string(),
  platformJson: __t.string().name("platform_json"),
  leaderId: __t.u64().name("leader_id"),
  strongCount: __t.u32().name("strong_count"),
  foundedAt: __t.timestamp().name("founded_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
